import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ModalDirective } from "ngx-bootstrap";
import { Location } from "../../../../objects/management/locationManagement/location";
import { NgForm, NgModel } from "@angular/forms";
import { Tuple } from "../../../../objects/common/Tuple";
import { LocationType } from "../../../../objects/management/locationManagement/locationType";
import { LocationService } from "../../../../services/locationService";
import { ResponseError } from "../../../../objects/common/responseError";
import { BlurUtil } from "../../../../common/utils/blurUtil";
import { EnumUtil } from "../../../../common/utils/EnumUtil";
import { LocationUtil } from "../../../../common/utils/LocationUtil";
import { LocationUpdateRequest } from "../../../../objects/requests/locationUpdateRequest";
import { ToastsManager } from "ng2-toastr";
import { OrderLocation } from "../../../../objects/management/order/orderLocation";

declare var $: any
/**
 * Created by alex.y on 8/2/2017.
 */

@Component({
    selector: "lm-create-modal",
    templateUrl: "./locationManagementCreateModal.component.html",
    moduleId: module.id.toString()
})
export class LMCreateModalComponent implements OnInit {
    @Output()
    public locationCreated: EventEmitter<OrderLocation> = new EventEmitter();

    // @Input()
    public locationProp: OrderLocation = new OrderLocation();

    public locationPropInput: OrderLocation = new OrderLocation();

    public originalLocation: OrderLocation;

    public errors: Array<ResponseError> = [];

    public locationTypeLink = LocationType;
    public processing: boolean;

    public isEditModal: boolean = false;

    @Input()
    private idToBlur: string;
    public enumUtil = EnumUtil;
    public locationFromString: string;

    public locationType: LocationType = null;

    public showForm: boolean = false;
    public changeOrder: boolean = false;
    public typeChanged: boolean = false;

    @ViewChild("locationModal") public locationModal: ModalDirective;
    @ViewChild("locationForm") public locationForm: NgForm;
    @ViewChild("location") public locationModel: NgModel;
    private updateRequest: LocationUpdateRequest;

    public constructor(public toastr: ToastsManager, private locationService: LocationService, private ChangeDetectorRef: ChangeDetectorRef) {
    }

    public ngOnInit(): void {
        this.locationModal.onHidden.subscribe((x: any) => this.onHiddenHandler());
    }

    public onHiddenHandler(): void {
        BlurUtil.unBlurMenu(this.idToBlur);

        $('#locationType').select2('destroy');
        $('#locationType').off('select2:select');
        $('#locationType').off('select2:unselect');
        this.locationForm.reset();
        this.showForm = false;
    }

    public hide(): void {
        this.locationModal.hide();
    }

    public show(isEditModal: boolean = false, location: Location = new Location()) {
        this.locationModal.show();
        this.showForm = true;
        this.changeOrder = false;
        this.isEditModal = isEditModal;

        //this.originalAgent = agent;
        this.locationProp = JSON.parse(JSON.stringify(location));
        this.locationPropInput = JSON.parse(JSON.stringify(location));
        this.originalLocation = JSON.parse(JSON.stringify(location));

        this.locationFromString = LocationUtil.formatAddress(this.locationProp, true);
        this.locationType = this.locationProp.Type;
        this.typeChanged = false;

        BlurUtil.blurMenu(this.idToBlur);
        setTimeout(x=>{
            this.initSelect2LocationType();
        }, 200)
    }

    public convertEnumToTuple(enumType: any): Array<any> {
        return EnumUtil.convertEnumToTuple(enumType);
    }

    private initSelect2LocationType(): void {
        var self = this;

        let tupl = (self.enumUtil.convertEnumToTuple(self.locationTypeLink));

        tupl.splice(tupl.indexOf(tupl.find(x => x.Key == 5)));

        $('#locationType').select2({
            width: '100%',
            data: self.generateSelectData(tupl),
            allowClear: true,
            placeholder: 'Select Type',
            closeOnSelect: true
        }).on('select2:select', function (e: any) {
            // self.orderItem.Currency = ;

            // let code: CanadianCurrencyCode = self.canadianCurrencyCodes.find(x => x.Code == $(this).val());
            // Object.assign(self.orderItem.CanadianCurrencyCode, code);

            self.locationType = $(this).val();

            self.typeChanged = self.originalLocation.Type != self.locationType;

            self.ChangeDetectorRef.detectChanges();
            self.locationModel.model.control.updateValueAndValidity();

        }).on('select2:unselect', function (e: any) {
            self.locationType = null;
            self.ChangeDetectorRef.detectChanges();
            self.locationModel.model.control.updateValueAndValidity();
        });


        $(`#locationType`).val(self.locationProp.Type).trigger("change");
    }

    public generateSelectData(data: Tuple<number, string>[]): any[] {
        let result = [];

        for (let item of data) {
            result.push({
                id: item.Key,
                text: item.Value
            });
        }

        return result;
    }

    public onLocationChange(location: OrderLocation) {
        this.locationProp = location;

        if (location != null)
            this.locationFromString = LocationUtil.formatAddress(location, true);

        this.ChangeDetectorRef.detectChanges();
        this.locationModel.model.control.updateValueAndValidity();
    }

    public createLocation(isValid: boolean) {
        if (!isValid)
            return;

        if (!this.locationProp)
            return;

        this.locationProp.Type = this.locationType;

        this.processing = true;

        this.locationService.modify(new LocationUpdateRequest({ Location: this.locationProp, ChangeOrders: this.changeOrder })).then((result) => {
            this.processing = false;

            if (!result || !result.Data)
                return;

            if (this.changeOrder)
                this.toastr.success("Orders were updated");

            this.locationCreated.emit(result.Data);
            this.hide();
        }).catch(() => {
            this.processing = false;
            this.toastr.error("Does not change any order");
        });
    }

}


// WEBPACK FOOTER //
// ./app/components/Managment/locationManagement/locationModals/locationManagementCreateModal.component.ts